import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { ExperimentOutlined } from '@ant-design/icons';
import BreedingEvents from "./index";
import ViewBreedingEvent from "./view";
import EditBreedingEvent from "./edit";

const breedingEventRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Breeding Events",
		basePath: "breeding-events",
		mainComponent: <BreedingEvents />,
	    layout: "/console",
		icon: <ExperimentOutlined className="h-6 w-6" />,
	    subTitle:"Breeding Event",
	    viewComponent: <ViewBreedingEvent />,
	    createComponent: <EditBreedingEvent />,
	    editComponent: <EditBreedingEvent />,
	})
]

export default breedingEventRoutes;